import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { IPlanningPayload } from '../interfaces/strategic-plan-planning.interface';
import { IPhasingPayload } from '../interfaces/strategic-plan-phasing.interface';
import { IEditAllPayload } from '../interfaces/strategic-plan-edit-all.interface';
import { getRequest, HandlerResponse, postFileUploadRequest, putRequest } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetStrategicPlanData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/strategicSalesPlan/getSalesPlanData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateStrategicPlanData = async (payload: IPlanningPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/strategicSalesPlan/editSalesPlanData${queryString}`, payload)
    .then((resp: any) => resp.text());
};

export const GetPhasingData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/strategicplan/phasing/PhasingGrid${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdatePhasingData = async (payload: IPhasingPayload[], queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/strategicplan/phasing/save${queryString}`, payload)
    .then((resp: any) => resp.text());
};

export const CopyDataToPlan = async (copyType: string, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/strategicSalesPlan/copyPlan/${copyType}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const FreezePlan = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/strategicSalesPlan/freezePlan${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const FreezePlanEditAll = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/strategicSalesPlan/freezePlan${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const ImportTemplate = async (file, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postFileUploadRequest(`${Environment.API}/excel/upload${queryString}`, file)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetEditAllData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/strategicplan/editall/displayEditAllScreen${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateEditAllData = async (payload: IEditAllPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/strategicplan/editall/save${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const ImportTemplateEditAll = async (file, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postFileUploadRequest(`${Environment.API}/excel/editAll/uploadTemplateEditAll${queryString}`, file)
    .then((resp: any) => HandlerResponse(resp));
};
